import React, { useState, useEffect } from 'react';
import { authFetch } from "../../utils/api";
import "../../styles/admin/admin-form.css"; 

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

export default function ConfiguracionBanner() {
  const [urlInput, setUrlInput] = useState("");
  const [currentBanners, setCurrentBanners] = useState([]);
  const [loading, setLoading] = useState(false);

  // Cargar lista actual
  const loadBanners = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/Banner`);
      const data = await res.json();
      if (data.banner_urls) setCurrentBanners(data.banner_urls);
    } catch (err) {
      console.error("Error cargando banners:", err);
    }
  };

  useEffect(() => { loadBanners(); }, []);

const handleAdd = async (e) => {
    e.preventDefault();
    if (!urlInput.trim()) return;

    setLoading(true);
    try {
      const response = await authFetch('/api/Banner/banner', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url: urlInput.trim() })
      });

      if (!response.ok) throw new Error("Error al guardar URL");
      
      alert("Banner agregado correctamente");
      setUrlInput(""); 
      loadBanners(); 
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  
  const handleDelete = async (urlToDelete) => {
    if (!window.confirm("¿Quitar esta imagen del carrusel?")) return;
    
    try {
     
      const response = await authFetch(`/api/Banner/banner?url=${encodeURIComponent(urlToDelete)}`, {
        method: 'DELETE'
      });

      if (response.ok) {
        loadBanners();
      } else {
        alert("No se pudo eliminar");
      }
    } catch (err) {
      alert("Error al eliminar: " + err.message);
    }
  };

  return (
    <div className="form-container">
      <h1>Gestión del Carrusel (URLs)</h1>
      
      {/* 1. Formulario para agregar URL */}
      <form onSubmit={handleAdd} style={{ marginBottom: '30px', borderBottom: '1px solid #ccc', paddingBottom: '20px' }}>
        <div className="form-group">
          <label>URL de la Imagen (Firebase, AWS, etc):</label>
          <input 
            type="url" 
            placeholder="https://ejemplo.com/imagen.jpg"
            value={urlInput}
            onChange={(e) => setUrlInput(e.target.value)}
            required
          />
        </div>
        
        {/* Vista previa pequeña antes de agregar */}
        {urlInput && (
          <div style={{ marginBottom: '10px' }}>
            <span style={{ fontSize: '0.9em', color: '#666' }}>Vista previa:</span><br/>
            <img src={urlInput} alt="Preview" style={{ height: '80px', marginTop: '5px', borderRadius: '4px' }} onError={(e) => e.target.style.display = 'none'} />
          </div>
        )}

        <button className="btn-submit" type="submit" disabled={loading}>
          {loading ? "Guardando..." : "Agregar al Carrusel"}
        </button>
      </form>

      {/* 2. Galería de Imágenes Activas */}
      <h3>Banners Activos</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '15px' }}>
        {currentBanners.length === 0 && <p style={{ color: '#888' }}>No hay imágenes configuradas.</p>}
        
        {currentBanners.map((url, idx) => (
          <div key={idx} style={{ position: 'relative', border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden' }}>
            {/* Imagen */}
            <img 
              src={url} 
              alt={`Banner ${idx}`} 
              style={{ width: '100%', height: '120px', objectFit: 'cover', display: 'block' }} 
            />
            
            {/* URL Text (para referencia) */}
            <div style={{ padding: '5px', fontSize: '10px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {url}
            </div>

            {/* Botón Borrar */}
            <button 
              onClick={() => handleDelete(url)}
              style={{
                position: 'absolute', top: 5, right: 5,
                background: 'rgba(255, 0, 0, 0.8)', color: 'white', border: 'none',
                borderRadius: '50%', width: '24px', height: '24px', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}
              title="Eliminar"
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}